export enum ProjectType {
IDE,
ImplementationStrategy,
}
